module.exports = __webpack_public_path__ + "img/10.cf588b12.jpg";